"use client";

import { useFormikContext } from "formik";

import { setUserInteractionDataAttribute } from "@shared/constants";

import Field from "@client/components/formik/field";
import Select from "@client/components/formik/select";
import Fieldset from "@client/components/lead-form/components/fieldset";

import { FormButton } from "@ui/js/components/buttons/form-button";

const INPUT_ID_AND_LABEL_HTMLFOR = "state";

export default function State() {
  const { setFieldValue } = useFormikContext();

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setFieldValue(INPUT_ID_AND_LABEL_HTMLFOR, e.currentTarget.value);
  };

  return (
    <>
      <Fieldset
        dialog="We request your address for three main reasons: to verify your identity, to conduct an accurate soft credit pull without affecting your score, and to match you with the best financial solutions. Your privacy is paramount to us; all data is encrypted and used with the utmost care."
        legend="What is your state of residence?"
      >
        <Field
          {...setUserInteractionDataAttribute(
            `lead-form_step_${INPUT_ID_AND_LABEL_HTMLFOR}`,
          )}
          id={INPUT_ID_AND_LABEL_HTMLFOR}
          name={INPUT_ID_AND_LABEL_HTMLFOR}
          label="State"
        >
          <Select
            id={INPUT_ID_AND_LABEL_HTMLFOR}
            name={INPUT_ID_AND_LABEL_HTMLFOR}
            onChange={handleChange}
          >
            <option value="" disabled>
              Select a state
            </option>
            <option value="AL">Alabama</option>
            <option value="AK">Alaska</option>
            <option value="AZ">Arizona</option>
            <option value="AR">Arkansas</option>
            <option value="CA">California</option>
            <option value="CO">Colorado</option>
            <option value="CT">Connecticut</option>
            <option value="DE">Delaware</option>
            <option value="DC">District Of Columbia</option>
            <option value="FL">Florida</option>
            <option value="GA">Georgia</option>
            <option value="HI">Hawaii</option>
            <option value="ID">Idaho</option>
            <option value="IL">Illinois</option>
            <option value="IN">Indiana</option>
            <option value="IA">Iowa</option>
            <option value="KS">Kansas</option>
            <option value="KY">Kentucky</option>
            <option value="LA">Louisiana</option>
            <option value="ME">Maine</option>
            <option value="MD">Maryland</option>
            <option value="MA">Massachusetts</option>
            <option value="MI">Michigan</option>
            <option value="MN">Minnesota</option>
            <option value="MS">Mississippi</option>
            <option value="MO">Missouri</option>
            <option value="MT">Montana</option>
            <option value="NE">Nebraska</option>
            <option value="NV">Nevada</option>
            <option value="NH">New Hampshire</option>
            <option value="NJ">New Jersey</option>
            <option value="NM">New Mexico</option>
            <option value="NY">New York</option>
            <option value="NC">North Carolina</option>
            <option value="ND">North Dakota</option>
            <option value="OH">Ohio</option>
            <option value="OK">Oklahoma</option>
            <option value="OR">Oregon</option>
            <option value="PA">Pennsylvania</option>
            <option value="RI">Rhode Island</option>
            <option value="SC">South Carolina</option>
            <option value="SD">South Dakota</option>
            <option value="TN">Tennessee</option>
            <option value="TX">Texas</option>
            <option value="UT">Utah</option>
            <option value="VT">Vermont</option>
            <option value="VA">Virginia</option>
            <option value="WA">Washington</option>
            <option value="WV">West Virginia</option>
            <option value="WI">Wisconsin</option>
            <option value="WY">Wyoming</option>
          </Select>
        </Field>
      </Fieldset>
      <FormButton
        {...setUserInteractionDataAttribute(
          `lead-form_submit-button_${INPUT_ID_AND_LABEL_HTMLFOR}`,
        )}
      />
    </>
  );
}
